export enum AdminUserType {
    ADMIN = 'admin',
    ONBOARDING_MANAGER = 'onboarding_manager',
    SUPER_ADMIN = 'super_admin',
}

/** String values match GraphQL `UserType` so admin list filters need no conversion layer. */
export enum UserType {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
}
